export default __webpack_public_path__ + "static/media/team39.ca36add9.JPG";